import { LoadState } from '../store';

export const commonFirstLoadHandler = <T>(state: T) => ({ ...state, loadState: LoadState.firstLoad, error: null });
export const commonLoadHandler = <T>(state: T) => ({ ...state, error: null });
export const commonErrorHandler = <T, E = Error>(state: T, { error }: { error: E }) => ({
  ...state,
  loadState: LoadState.error,
  error
});
